<template>
  <div class="flipbook-viewport">
    <div class="container">
      <div class="flipbook">
        <div>
          <div
            style="
              background-image: url(http://localhost:55105/Resources/Downloads/pages/1.jpg);
            "
          ></div>
          <div
            style="
              background-image: url(http://localhost:55105/Resources/Downloads/pages/2.jpg);
            "
          ></div>
          <div
            style="
              background-image: url(http://localhost:55105/Resources/Downloads/pages/3.jpg);
            "
          ></div>
          <div
            style="
              background-image: url(http://localhost:55105/Resources/Downloads/pages/4.jpg);
            "
          ></div>
        </div>
        <div
          style="
            background-image: url(http://localhost:55105/Resources/Downloads/pages/1.jpg);
          "
        ></div>
        <div
          style="
            background-image: url(http://localhost:55105/Resources/Downloads/pages/2.jpg);
          "
        ></div>
        <div
          style="
            background-image: url(http://localhost:55105/Resources/Downloads/pages/3.jpg);
          "
        ></div>
        <div
          style="
            background-image: url(http://localhost:55105/Resources/Downloads/pages/4.jpg);
          "
        ></div>
        <div
          style="
            background-image: url(http://localhost:55105/Resources/Downloads/pages/5.jpg);
          "
        ></div>
        <div
          style="
            background-image: url(http://localhost:55105/Resources/Downloads/pages/6.jpg);
          "
        ></div>
        <div
          style="
            background-image: url(http://localhost:55105/Resources/Downloads/pages/7.jpg);
          "
        ></div>
        <div
          style="
            background-image: url(http://localhost:55105/Resources/Downloads/pages/8.jpg);
          "
        ></div>
        <div
          style="
            background-image: url(http://localhost:55105/Resources/Downloads/pages/9.jpg);
          "
        ></div>
        <div
          style="
            background-image: url(http://localhost:55105/Resources/Downloads/pages/10.jpg);
          "
        ></div>
        <div
          style="
            background-image: url(http://localhost:55105/Resources/Downloads/pages/11.jpg);
          "
        ></div>
        <div
          style="
            background-image: url(http://localhost:55105/Resources/Downloads/pages/12.jpg);
          "
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
require("./turn.js");
export default {
  mounted() {
    $(".flipbook").turn({
      width: 922,
      height: 600,
      elevation: 50,
      gradients: true,
      autoCenter: true,
    });
  },
};
</script>
